// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__5Ih1h"};